module.exports = __webpack_public_path__ + "static/img/cardbg3.c6eecec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardbg3.png
// module id = hELU
// module chunks = 1